import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Creators from "@/pages/admin/Creators";
import CreatorProfile from "@/pages/admin/CreatorProfile";
import Brands from "@/pages/admin/Brands";
import Campaigns from "@/pages/admin/Campaigns";
import CampaignDetail from "@/pages/admin/CampaignDetail";
import CRM from "@/pages/admin/CRM";
import Analytics from "@/pages/admin/Analytics";
import Tasks from "@/pages/admin/Tasks";
import Applications from "@/pages/admin/Applications";
import AuditLog from "@/pages/admin/AuditLog";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="creators" element={<Creators />} />
                <Route path="creators/:id" element={<CreatorProfile />} />
                <Route path="brands" element={<Brands />} />
                <Route path="campaigns" element={<Campaigns />} />
                <Route path="campaigns/:id" element={<CampaignDetail />} />
                <Route path="crm" element={<CRM />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="tasks" element={<Tasks />} />
                <Route path="applications" element={<Applications />} />
                <Route path="audit" element={<AuditLog />} />
                <Route path="settings" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors theme="dark" position="bottom-right" />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
